import { i18n } from '../../../shared/helpers/i18n';
import { ConferenceHistoryItem } from '../types';
import { formatConfShortUrlId } from './format-conf-short-url-id';

export const getConferenceTitle = (conference: ConferenceHistoryItem) => {
    const formattedShortUrlId = formatConfShortUrlId(conference.shortUrlId);
    return conference.meetingName || i18n('conferences-history', 'conference-number', { id: formattedShortUrlId });
};
